<ng-container *ngIf="course.syllabus; let syllabus">
  <ng-container *ngFor="let item of syllabus.numberingList; index as i">
    <form class="w-100 title-form" [ngClass]=AppConfig.theme (ngSubmit)="onSubmit(syllabus)">
      <div class="list-block mb-4">
        <div class="list-block-header w-100">
          <button mat-mini-fab color="accent" class="d-inline-block">
            <input class="text-center" matInput [(ngModel)]="item.number" name="number"/>
          </button>
          <button mat-icon-button class="p-absolute right-20" (click)="removeNumberingListItem(i)">
            <mat-icon class="color-gray">delete</mat-icon>
          </button>

          <h3 class="p-relative px-3">
            <mat-form-field class="w-100">
              <input placeholder="타이틀을 입력해주세요." class="text-left" matInput [(ngModel)]="item.title" name="title"/>
            </mat-form-field>
          </h3>
        </div>
        <p class="p-2 px-5 mx-4 p-relative">
          <mat-form-field class="w-100">
            <textarea placeholder="내용을 입력해주세요." rows="3" matInput [(ngModel)]="item.content" name="content"></textarea>
          </mat-form-field>
        </p>
      </div>
    </form>
  </ng-container>
  <button class="p-absolute" mat-fab color="accent" (click)="addNumberingListItem()">
    <mat-icon>add</mat-icon>
  </button>
  <button class="p-absolute right-30" mat-raised-button color="accent" type="submit" (click)="onSubmit(syllabus)">저장</button>
</ng-container>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/syllabuses/syllabus-numbering-list-edit/syllabus-curriculum-numbering-list-edit.component.html